var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSystemHealth24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_system_health24x24",
    transform: "translate(-3.996 -3.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M1145.1,349.656a1,1,0,0,0,1-1v-3h3a1,1,0,0,0,1-1v-4a1,1,0,0,0-1-1h-3v-3a1,1,0,0,0-1-1h-4a1,1,0,0,0-1,1v3h-3a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h3v3a1,1,0,0,0,1,1h4m0,1h-4a2,2,0,0,1-2-2v-2h-2a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h2v-2a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v2h2a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2h-2v2A2,2,0,0,1,1145.1,350.656Z",
    transform: "translate(-1131.104 -330.66)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSystemHealth24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_system_health24x24.286b3e380508fef2e26992f8d8f117a5.svg";